import { z } from 'zod'

export const GetCartSchema = z.object({
    cart_id: z.string().min(1),
})
